import AreaContainer from "../AreaContainer";
import { useDispatch } from "react-redux";
import { modalSet, nextModalSet } from "_slices/view";
import logEvent from "lib/ga/miscEvent"
import AgentsList from "./AgentsList";
import dynamic from "next/dynamic";
import { Loading } from "components/Loading";
import styles from './agents.module.css';
import globalStyles from '../result.module.css';
const Ads = dynamic(() => import("../ads"), {
    loading: () => <Loading />,
    ssr: true
})
import { useRouter } from 'next/navigation'

const LocalAgents = ({ agents, id, isLoggedIn, unfilteredAgents, payingClient, type, showPage }) => {
    let dispatch = useDispatch();
    const router = useRouter();
    const agentContactDetails = `You are seeing the agent listing the property as you are logged in as an agent to the Completely Retail platform.  ${unfilteredAgents?.length === 1 ? "This agent is" : "These agents are"} not visible to visitors to the Completely Retail website.`;
    const noContactDetails = 'We cannot share contact information for this property. However, we do know agents that work nearby. Get in touch with one of our recommended local experts if you need help finding other shops to rent in the area.';
    const noAgentsAtAll = 'Sorry, we do not have contact information for this property at the moment.';
    return (
        <AreaContainer area="agents" style={null} extraClass={null}>
            <div className={styles.UpgradeWrapper}>
                <div className={styles.upgradeContain}>
                    <h2 className={globalStyles.subTitleText}>{payingClient && unfilteredAgents?.length > 0 ? 'Agents' : `Unsponsored ${type} contact details not available`}</h2>
                    <p className={`${globalStyles.mediumText} ${globalStyles.largeLineHeight}`}>
                        {payingClient && unfilteredAgents?.length > 0 ? agentContactDetails : agents?.length > 0 ? noContactDetails : noAgentsAtAll}
                    </p>
                    {Boolean(agents) && agents.length > 0 && (
                        <div className={styles.buttonContainerContact}>
                            <div className={styles.smallButton} onClick={(e) => {
                                logEvent({
                                    category: "Local agent Contact",
                                    action: "Email modal opened",
                                    label: `Property: ${id}`,
                                });
                                if (isLoggedIn) {
                                    dispatch(
                                        modalSet({
                                            visible: true,
                                            type: "localAgentsContact",
                                            view: id,
                                            router
                                        })
                                    );
                                } else {
                                    dispatch(
                                        modalSet({
                                            visible: true,
                                            type: "auth",
                                            view: "login",
                                            router,
                                            propertyPage: true
                                        })
                                    );
                                    dispatch(
                                        nextModalSet({
                                            visible: true,
                                            type: "localAgentsContact",
                                            view: id.toString(),
                                            router
                                        })
                                    );
                                }
                            }}>
                                <div className={globalStyles.largeText} > {agents?.length > 0 ? 'Contact Local Experts' : 'Property contact details not available'} </div>
                            </div>
                        </div>
                    )}
                </div>
            </div>
            {Boolean(payingClient) && (unfilteredAgents?.length > 0) && (
                <AgentsList agents={unfilteredAgents} contactable={true} sponsored={true} id={id} title={""} type={""} display={""} showAllAgentContacts={false} />
            )}

            {Boolean(agents) && agents.length > 0 && (
                <div className={styles.GridContainer} id="agent-contain">
                    <div className={styles.gridRow}>
                        <h2 className={globalStyles.subTitleText}> <img alt='approved agents' src='/icons/approvedAgents.svg' loading="lazy" height="30" width="30"></img> <span>Local Experts</span></h2>
                    </div>
                    <div className={styles.contentRow}>
                        {agents.map((agent) => {
                            return (
                                <AgentListItem key={agent.id} company={agent} />
                            );
                        })}
                    </div>
                </div>
            )}
            {Boolean(agents) && agents.length === 0 && showPage && (
                <Ads style={{ display: "block", height: '250px', width: 'auto' }} includeScript={false} />
            )}
        </AreaContainer>
    )
}

const AgentListItem = ({ company }) => {
    return (
        <div className={styles.agentSlideContainer}>
            <div className={styles.companyPadder} >
                <div className={styles.companyContainer}>
                    <div className={styles.companyLogo}>
                        {company.logo_uri &&
                            <img alt={`${company.name} logo`} src={`${process.env.NEXT_PUBLIC_APP_MEDIA_URL}${company.logo_uri}`} loading="lazy" height="auto" width="auto"></img>}
                    </div>
                    <div className={styles.agentDetails}>
                        <p className={globalStyles.largeText}>{company.name}</p>
                    </div>
                </div>
            </div>
        </div>
    )
}



export default LocalAgents;
